import KBBDealIndicatorOverlay from './KBBDealIndicatorOverlay';
export default KBBDealIndicatorOverlay;